















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Loading, Icon } from 'vant'

import Deliver from '../deliver.vue'

@Component({
  components: {
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    Deliver,
  },
})
export default class ShowMore extends Vue {
  @Prop({ default: false }) readonly completed!: string
  @Prop({ default: false }) readonly isFetching!: boolean
  @Prop({ default: false }) readonly withArrow!: boolean
}
